module.exports = __webpack_public_path__ + "static/media/0@3x.6177caf7.png";